module.exports = __webpack_public_path__ + "img/xiaohe1.c8b45e1f.png";